module.exports = __webpack_public_path__ + "img/BG.0f701f8a.svg";